export const ANNA_LINK = 'https://share.hsforms.com/1dFfg5c0YRv2C0HbBVM-bCg39ba7'

export const COLLECTIONS = {
  PLACES: 'places',
  ACTIVITIES_ENTERTAINMENT: 'activities-entertainment',
  SERVICES: 'services'
}

export const getPage = (collection) => {
  switch (collection) {
    case COLLECTIONS.ACTIVITIES_ENTERTAINMENT:
      return 'actividades'
    case COLLECTIONS.SERVICES:
      return 'servicios'
    case COLLECTIONS.PLACES:
    default:
      return 'lugares'
  }
}

/**
 * Valid internal params to send to the backend via API
 * @param {string} collection
 */
export const getValidRequestParams = (collection) => {
  switch (collection) {
    case COLLECTIONS.ACTIVITIES_ENTERTAINMENT:
    case COLLECTIONS.SERVICES:
      return {
        search: 'search',
        bounds: 'bounds',
        date: 'date',
        ages: 'ages',
        search_category: 'search_category',
        rating_category: 'rating_category',
        attributes: 'attributes'
      }
    case COLLECTIONS.PLACES:
    default:
      return {
        search: 'search',
        bounds: 'bounds',
        municipality: 'municipality',
        ages: 'ages',
        search_category: 'search_category',
        rating_category: 'rating_category',
        attributes: 'attributes'
      }
  }
}

/**
 * Valid params for the URL depending on the collection
 * @param {string} collection
 */
export const getValidURLParams = (collection) => {
  switch (collection) {
    case COLLECTIONS.ACTIVITIES_ENTERTAINMENT:
    case COLLECTIONS.SERVICES:
      return {
        search: 'search',
        latitude: 'latitude',
        longitude: 'longitude',
        date: 'date',
        ages: 'ages',
        search_category: 'search_category',
        rating_category: 'rating_category',
        attributes: 'attributes'
      }
    case COLLECTIONS.PLACES:
    default:
      return {
        search: 'search',
        latitude: 'latitude',
        longitude: 'longitude',
        municipality: 'municipality',
        ages: 'ages',
        search_category: 'search_category',
        rating_category: 'rating_category',
        attributes: 'attributes'
      }
  }
}

/**
 * Valid params for filters (there is a filter component in the web)
 * @param {string} collection
 */
export const getValidFilterParams = (collection) => {
  switch (collection) {
    case COLLECTIONS.ACTIVITIES_ENTERTAINMENT:
    case COLLECTIONS.SERVICES:
      return {
        search: 'search',
        latitude: 'latitude',
        longitude: 'longitude',
        date: 'date',
        ages: 'ages',
        search_category: 'search_category',
        attributes: 'attributes'
      }
    case COLLECTIONS.PLACES:
    default:
      return {
        search: 'search',
        latitude: 'latitude',
        longitude: 'longitude',
        ages: 'ages',
        search_category: 'search_category',
        attributes: 'attributes'
      }
  }
}
